import { useContext, useEffect, useState } from 'react';
import CurrentUser from '~/contexts/CurrentUser';
import Dashboard from '@material-ui/icons/Dashboard';
import People from '@material-ui/icons/People';
import FileIcon from '@material-ui/icons/Description';
import Send from '@material-ui/icons/Send';
import CardMembership from '@material-ui/icons/CardMembership';
import SupervisedUserCircle from '@material-ui/icons/SupervisedUserCircle';
import Refresh from '@material-ui/icons/Refresh';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import ChatBubble from '@material-ui/icons/ChatBubble';
import Image from '@material-ui/icons/Image';
import HeadsetMic from '@material-ui/icons/HeadsetMic';
import ReceiptIcon from '@material-ui/icons/Receipt';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import BusinessIcon from '@material-ui/icons/Business';
import AttendantWebSocket from '~/contexts/AttendantWebSocket';
import Request from '~/providers/Request';
import CategoryIcon from '@material-ui/icons/Category';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import FiberPinIcon from '@material-ui/icons/FiberPin';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import AssessmentIcon from '@material-ui/icons/Assessment';
import LocalActivity from '@material-ui/icons/LocalActivity';
import AutorenewIcon from '@material-ui/icons/Autorenew';

import {
  dashboards,
  specialties,
  packs,
  products,
  pins,
  epayTransactions,
  schedules,
  chats,
  partnersDashboard,
  peoples,
  medicalAppointments,
  medicalAppointmentsReports,
  files,
  sendPush,
  cards,
  subscription,
  addon,
  corporation,
  faq,
  partner,
  packageBillings,
  planBillings,
  tourImage,
  appointmentCategories,
  appointmentTags,
  reportUsersActives,
  reportPackagesActives,
  reportPackagesEspecialtyActives,
  reportStation,
  sales,
  SIDMedicalAppointmentsReports,
  accidentReports,
  appointmentRating,
  logsReports,
  pendingFiles,
  activeClients,
  coupon,
  reportIdsIntegration,
  reportMevoPrescricoes,
  whatsappCampaign,
  appointmentConfirmations,
  preRegistrationCampaign,
  infobipAccess,
} from '~/config/routes';
import toInt from '~/utils/Number/toInt';
import notification from '~/assets/audios/notification.mp3';

export default (t) => {
  const { user } = useContext(CurrentUser);
  const { webSocket, attendant } = useContext(AttendantWebSocket);
  const [notificationsChat, setNotificationsChat] = useState(null);
  const audio = new Audio(notification);

  const fetchMessages = async () => {
    try {
      const response = await Request.get(
        '/admin/chats/new_messages',
        {},
        { normalizeJSON: false }
      );

      if (toInt(response?.count) > 0) {
        setNotificationsChat(response?.count);
      } else {
        setNotificationsChat(null);
      }
    } catch (error) {
      setNotificationsChat(null);
    }
  };

  useEffect(() => {
    if (notificationsChat) {
      audio.play();
    }
  }, [notificationsChat]);

  useEffect(() => {
    if (attendant && webSocket) {
      webSocket.on('message', async () => {
        fetchMessages();
      });
    }
  }, [attendant, webSocket]);

  useEffect(() => {
    fetchMessages();
  }, []);

  function openInNewTab(url) {
    return window.open(url, '_blank').focus();
  }

  if (user.role === 'partner') {
    return [
      {
        route: partnersDashboard,
        text: partnersDashboard.title,
        Icon: Dashboard,
      },
    ];
  }

  return [
    {
      route: dashboards,
      text: dashboards.title,
      Icon: Dashboard,
    },
    {
      route: peoples,
      text: peoples.title,
      Icon: People,
    },
    {
      route: corporation,
      text: corporation.title,
      Icon: BusinessIcon,
    },
    {
      route: schedules,
      text: schedules.title,
      Icon: LocalHospitalIcon,
    },
    {
      route: chats,
      text: chats.title,
      Icon: LocalHospitalIcon,
      notifications: notificationsChat,
    },
    {
      route: specialties,
      text: specialties.title,
      Icon: LocalHospitalIcon,
    },
    {
      route: medicalAppointments,
      text: medicalAppointments.title,
      Icon: LocalHospitalIcon,
    },
    {
      route: pendingFiles,
      text: pendingFiles.title,
      Icon: LocalHospitalIcon,
    },
    {
      route: medicalAppointmentsReports,
      text: 'Consultas realizadas',
      Icon: LocalHospitalIcon,
    },
    {
      route: packageBillings,
      text: packageBillings.title,
      Icon: ReceiptIcon,
    },
    {
      route: planBillings,
      text: planBillings.title,
      Icon: ReceiptIcon,
    },
    {
      route: files,
      text: files.title,
      Icon: FileIcon,
    },
    {
      route: sendPush,
      text: sendPush.title,
      Icon: Send,
    },
    {
      route: cards,
      text: cards.title,
      Icon: CardMembership,
    },
    {
      route: coupon,
      text: coupon.title,
      Icon: LocalActivity,
    },
    {
      route: packs,
      text: packs.title,
      Icon: MonetizationOn,
    },
    {
      route: products,
      text: products.title,
      Icon: ReceiptIcon,
    },
    {
      route: pins,
      text: pins.title,
      Icon: FiberPinIcon,
    },
    {
      route: epayTransactions,
      text: epayTransactions.title,
      Icon: SyncAltIcon,
    },
    {
      route: subscription,
      text: subscription.title,
      Icon: Refresh,
    },
    {
      route: addon,
      text: addon.title,
      Icon: MonetizationOn,
    },
    {
      route: partner,
      text: partner.title,
      Icon: SupervisedUserCircle,
    },
    {
      route: appointmentCategories,
      text: appointmentCategories.title,
      Icon: CategoryIcon,
    },
    {
      route: appointmentTags,
      text: appointmentTags.title,
      Icon: LocalOfferIcon,
    },
    // {
    //   // dividerTop: true,
    //   text: t('menu-rating'),
    //   Icon: Add,
    //   items: [
    //     {
    //       route: rating,
    //       text: rating.title,
    //       Icon: Star,
    //     }, {
    //       route: ratingUseful,
    //       text: ratingUseful.title,
    //       Icon: ThumbUp,
    //     }, {
    //       route: ratingStatistics,
    //       text: ratingStatistics.title,
    //       Icon: ShowChart,
    //     },
    //   ],
    // },
    {
      route: faq,
      text: faq.title,
      Icon: ChatBubble,
    },
    {
      route: tourImage,
      text: tourImage.title,
      Icon: Image,
    },
    {
      text: t('menu-reports'),
      Icon: AssessmentIcon,
      items: [
        {
          route: reportUsersActives,
          text: reportUsersActives.title,
        },
        {
          route: reportPackagesActives,
          text: reportPackagesActives.title,
        },
        {
          route: reportPackagesEspecialtyActives,
          text: reportPackagesEspecialtyActives.title,
        },
        {
          route: sales,
          text: sales.title,
        },
        {
          route: accidentReports,
          text: accidentReports.title,
        },
        {
          route: appointmentRating,
          text: appointmentRating.title,
        },
        {
          route: logsReports,
          text: logsReports.title,
        },
        {
          route: SIDMedicalAppointmentsReports,
          text: SIDMedicalAppointmentsReports.title,
        },
        {
          route: activeClients,
          text: activeClients.title,
        },
        {
          route: reportIdsIntegration,
          text: reportIdsIntegration.title,
        },
        {
          route: reportMevoPrescricoes,
          text: reportMevoPrescricoes.title,
        },
        {
          route: reportStation,
          text: reportStation.title,
        },
      ],
    },
    {
      text: t('menu-automations'),
      Icon: AutorenewIcon,
      items: [
        {
          route: whatsappCampaign,
          text: whatsappCampaign.title,
        },
        {
          route: appointmentConfirmations,
          text: appointmentConfirmations.title,
        },
        {
          route: preRegistrationCampaign,
          text: preRegistrationCampaign.title,
        },
        {
          route: infobipAccess,
          text: infobipAccess.title,
        },
      ],
    },
    {
      text: t('menu-zendesk'),
      Icon: HeadsetMic,
      onClick: () => openInNewTab('https://www.zendesk.com.br'),
      dividerTop: true,
      external: true,
      dividerBottom: true,
    },
  ];
};
